module.exports = __webpack_public_path__ + "static/media/speakerOne.b815916c.jpg";